import React from 'react';
import { Button, Space } from 'antd';
import { BED_METRICS, type BedMetricKey } from '../constants';

interface BedMetricSelectorProps {
  selectedMetric: BedMetricKey;
  onSelectMetric: (key: BedMetricKey) => void;
}

const BedMetricSelector: React.FC<BedMetricSelectorProps> = ({
  selectedMetric,
  onSelectMetric,
}) => (
  <Space wrap size={[6, 6]} style={{ marginBottom: 8 }}>
    {BED_METRICS.map(m => (
      <Button
        key={m.key}
        size="small"
        type={selectedMetric === m.key ? 'primary' : 'default'}
        style={
          selectedMetric === m.key
            ? { backgroundColor: m.color, borderColor: m.color }
            : { color: m.color, borderColor: m.color }
        }
        onClick={() => onSelectMetric(m.key)}
      >
        {m.label}
      </Button>
    ))}
  </Space>
);

export default BedMetricSelector;
